export default __webpack_public_path__ + "static/media/login.da6b08f2.jpg";